import React from 'react';
import { LayoutWithHeader } from '@components/layout/LayoutWithHeader';
import routes from '@config/routes';
import strings from '@config/strings';
import { PromoCta } from '@goodfynd/content';
import { getDashboardRoutePath } from '@utils/routes-util';
import Head from 'next/head';

import { setPageTitle } from '../utils/base';

function Home(): JSX.Element {
  return (
    <>
      <Head>
        <title>{setPageTitle('Home')}</title>
        <meta content="home page" name="description" />
      </Head>

      <PromoCta
        button_text="Get Started"
        image="/images/bg/home.svg"
        image_position="right"
        title={strings.titles.homeTitle}
        buttonOnClick={() => {
          window.location.href = getDashboardRoutePath(
            routes.dashboard.overview,
            '~'
          );
        }}
        content="Streamline your operations, boost your sales, and delight your
          customers."
      />
    </>
  );
}

Home.getLayout = function getLayout(page: React.ReactElement) {
  return <LayoutWithHeader>{page}</LayoutWithHeader>;
};

export default Home;
